module.exports = __webpack_public_path__ + "img/express.ed4d88f0.svg";